module.exports = __webpack_public_path__ + "static/media/droetker-1x.93e6c519.jpg";